export default {
    MODEL_TYPES:{
        "GROUP":"group",
        "MAINSKU":"mainsku",
        "COUPON":"coupon",
        "CTO":"cto",
        "GIFT":"gift",
        "OPTION":"option",
        "PACKAGE":"package",
        "SERVICE":"service",
        "BOOKING":"booking",
        "KILL":"kill",
        "ORDER_REDUCE":"orderReduce",
        "SUBSCRIBE":"subscribe",
        "SUBSCRIBESNAP":"subscribeSnap",
        "PRICE":"price",
        "RECOMMEND":"Recommend",
        "GOODLIST":"GoodList",
        "SIMILAR":"Similar",
        "ACTIVEPRICE":'PriceActive',
        "SERVICELIST":"servicelist",
        "OPTIONLIST":"optionlist",
        "PERSONALTAILOR":"personalTailor",
        "GIFTLIST":"giftlist",
        "SIMILARITYGOODS":"similaritygoods",
        "ARRIVALGOODS":"arrivalgoods",
        "KILL_COUNTDOWN":"killcountdown",
    },
    GROUP_TYPE:{
        "SINGLE":{
            TYPE:"0",
            NAME:"单品"
        },
        "OPTION":{
            TYPE:"2",//和9一样，skus里面除了第一条数据是主品，其他的都是选件
            NAME:"选件"
        },
        "PACKAGE":{
            TYPE:"3",//和9一样，skus里面除了第一条数据是主品，其他的都是套餐
            NAME:"套餐"
        },
        "FULL_REDUCE":{
            TYPE:"9",
            NAME:"满减"//skus里面都是主品，其他信息从sku单条数据去取
        }
    },
    ADDITIONAL_TYPE:{
        "CTO":"cto",
        // "PERSONALTAILOR":"personalTailor",
        "GIFT":"gift",
        "OPTION":"option",
        "SERVICE":"service",
        "COUPON":"coupon",
        "PACKAGE":"package",
        "SERVICELIST":"servicelist",
        "OPTIONLIST":"optionlist",
        "GIFTLIST":"giftlist",
        "SIMILARITYGOODS":"similaritygoods",
        "PERSONALGOODS":"personalgoods",
        "ARRIVALGOODS":"arrivalgoods"
    },
    SALES_TYPE:{
        BOOKING:{
            TYPE:2,
            NAME:"预售"
        }
    },
    PROMOTION_TYPE:{
        "BOOKING":{
            TYPE:"booking",
            NAME:"预售"
        },            
        "KILL":{
            TYPE:"2",
            NAME:"秒杀"
        },                     
        "ORDER_REDUCE":{
            TYPE:"7",
            NAME:"下单立减"
        },             
        "SUBSCRIBE":{
            TYPE:"5",
            NAME:"预约"
        },                
        "SUBSCRIBE_SNAP":{
            TYPE:"3",
            NAME:"预约抢购"
        },
        "KILL_COUNTDOWN":{
            TYPE:"4",
            NAME:"秒杀倒计时"
        },                                
    },
    EVENT_KEY:{
        'PRICE':'priceChanged',
        'REMOVE_MAINSKU':"remove_mainSku",
        'REMOVE_SERVICE':'remove_service',
        'MODIFY_MAINSKU_COUNT':"modify_count",
        "CHANGE_MAINSKU_ACTIVE":"change_mainsku_active",
        "CHANGE_ALL_ACTIVE":"change_all_active",
        "MODIFY_PACKAGE_COUNT":"modify_package_count",
        "CHANGE_PACKAGE_ACTIVE":"change_package_active",
        "REMOVE_GROUP":"remove_group",
        "RERENDER_CART":"rerender_cart"
    },
    MSG:{
        'STOCK':"库存紧张",
        'CART_ERROR':"获取购物车失败!",
        "INVALID":"已失效",
        "NOCHECKED":"请至少选择1件商品进行结算！",
        'NOSTOCK':"已售罄",
        "NO_MARKETABLE":"已下架",
        "SKU_INVALID":"该商品无法购买!",
        "CANNOT_BATCHR_REMOVE":"请至少选择1件商品！",
        "CANNOT_BATCHR_REMOVE_INVALID":"至少选中一件无效商品才能进行删除",
        "CANNOT_BATCHR_ADD_FAV":"请至少选择1件非套餐商品！",
        "NOT_LOGIN":"未登录不允许进行此操作!",
        "CANNOT_BATCH_ACTIVE":"至少选中一件商品才能进行批量激活",
        "ONLY_PACKAGE_NO_ADD_FAV":"套餐商品暂不支移入收藏夹",
        "PACKAGE_NO_ADD_FAV":"套餐商品暂不支移入收藏夹, 其他商品已移入收藏夹",
        "GOOD_UPPER_LIMIT":"该商品您最多只能购买5个",
        "CONFIRM_REMOVE_INVALID_GOODS":"确认清空失效商品吗？",
        "NO_INVALID_GOODS":"购物车里面没有失效商品",
        'STOCK_NOT_ENOUGH':"库存不足",
        "MODIFYING":"正在修改数量...",
        "ACTIVEING":"正在处理当前商品的选中状态...",
        "NOGIFT":"已赠完"
    },
    TERMINAL:{
        PC:"1",
        WAP:"2"
    }
    // SKU_ADDITIONAL_TYPE:{
    //     SERVICES:{
    //         containsService:false,  //是否显示这个  选择服务的按钮
    //         services:[],            //已经选择的服务
    //         dataSource:[]           //所有服务的数据源
    //     },
    //     GIFT:{
    //         GIFTS:[],               //已经选择的赠品
    //         OPTIONGIFTFLAG:false,   //是否显示重选按钮
    //         dataSource:[]           //赠品数据源
    //     },                             
    //     CTO:{
    //         personalization:[],     //在sku层级里面的attributes字段
    //         dataSource:[]           //CTO数据源
    //     }
    // }
}

//Group里面的title，从stips里面取，必须是item_type = 9
//其他item_type的title，
//1:下单立减，取 promotions(Array)
//2:秒杀        取activity(json)    type = 2
//3:预约        取activity(json)    type = 5
//4:预约抢购     取activity(json)    type = 3
//5：预售       sku里面的第一级数据源 salesType = 2, presellStartTime为空就是活动没开始，否则就是倒计时
//presellStartTime 预售活动开始时间
//presellEndTime   预售活动结束时间
//tailPaymentDay   尾款支付结束时间
//despoitEndTime   定金结束时间
//只有主品下面有比价，取 priceComparisonDesc字段即可

//Group 0 2 3 9 5
//Group根据类型，允许下面的主品SKU搭配所有的<附属商品：服务，选件，赠品，私人订制>, 只不过选件只能出现在Group item_type = 2的上面
//SKU主品，都允许有 选择服务，领券，促销政策(下单立减, 秒杀, 预约, 预约抢购, 预售)
